import Document from "../general/document";

export interface HourTypeData {
  description: string;
}

class HourType extends Document<HourTypeData> {
  get title() {
    return this.data.description;
  }
}

export default HourType;
